/* Haye Nii (brand audit 2, batch B): the "More" languages list (snippets/hn-language-buttons.liquid).
   "More" opens the website's own list under the language row (same look and keys as the option lists in
   assets/product-options.js); picking a language closes it and the button then shows that language.
   Used by assets/name-personalization.js (name box) and assets/hn-name-search.js (name search):
     var more = window.hnLangMore(wrapElement, function (language) { ... });  more.set('Tamil'); more.set('English');
   Only one list is open at a time. The cart never reads this: the name box keeps its own hidden "Language" field. */
(function () {
  if (window.hnLangMore) return;
  var open = null;

  function bottomKeepOut() {
    // room for the chat bubble at the bottom right (the phone "Add to cart" card steps aside: html.hn-dd-open)
    return Math.min(96, window.innerHeight * 0.12);
  }

  function close(focusButton) {
    if (!open) return;
    var o = open;
    open = null;
    o.list.hidden = true;
    o.button.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('hn-dd-open');
    if (focusButton && o.button.isConnected) o.button.focus({ preventScroll: true });
  }

  function show(o) {
    close(false);
    o.list.hidden = false;
    o.button.setAttribute('aria-expanded', 'true');
    open = o;
    document.documentElement.classList.add('hn-dd-open');
    var items = o.items();
    var current = o.list.querySelector('[aria-selected="true"]') || items[0];
    if (current) {
      o.list.scrollTop = Math.max(0, current.offsetTop - o.list.clientHeight / 2);
      current.focus({ preventScroll: true });
    }
    var overflow = o.list.getBoundingClientRect().bottom - (window.innerHeight - bottomKeepOut());
    if (overflow > 0) {
      var startY = window.scrollY;
      window.scrollBy({ top: overflow, behavior: 'smooth' });
      // some browsers skip smooth scrolling (power saving, hidden tab): then jump, so the last choices are never hidden
      setTimeout(function () {
        if (open === o && Math.abs(window.scrollY - startY) < 1) window.scrollBy(0, overflow);
      }, 400);
    }
  }

  document.addEventListener('pointerdown', function (event) {
    if (!open || !event.target.closest) return;
    if (event.target.closest('[data-hn-lang-list]') === open.list || event.target.closest('[data-hn-lang-more]') === open.button) return;
    close(false);
  });
  window.addEventListener('pagehide', function () { close(false); });

  window.hnLangMore = function (wrap, onPick) {
    var button = wrap.querySelector('[data-hn-lang-more]');
    var list = wrap.querySelector('[data-hn-lang-list]');
    var label = wrap.querySelector('[data-hn-lang-more-label]');
    if (!button || !list) return { set: function () {}, has: function () { return false; } };
    var o = {
      button: button,
      list: list,
      items: function () { return Array.prototype.slice.call(list.querySelectorAll('[data-value]')); }
    };

    function pick(item) {
      close(true);
      onPick(item.getAttribute('data-value'));
    }

    button.addEventListener('click', function () {
      if (button.disabled) return;
      if (open === o) close(false);
      else show(o);
    });
    button.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        show(o);
      } else if (event.key === 'Escape' && open === o) {
        close(true);
      }
    });
    list.addEventListener('click', function (event) {
      var item = event.target.closest('[data-value]');
      if (item) pick(item);
    });
    list.addEventListener('keydown', function (event) {
      var items = o.items();
      var index = items.indexOf(event.target);
      var next = null;
      if (event.key === 'ArrowDown') next = items[Math.min(items.length - 1, index + 1)];
      else if (event.key === 'ArrowUp') next = items[Math.max(0, index - 1)];
      else if (event.key === 'Home') next = items[0];
      else if (event.key === 'End') next = items[items.length - 1];
      if (next) {
        event.preventDefault();
        next.focus();
      } else if ((event.key === 'Enter' || event.key === ' ') && index >= 0) {
        event.preventDefault();
        pick(items[index]);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      } else if (event.key === 'Tab') {
        close(true);
      }
    });

    return {
      // true when the language is one of the list's choices
      has: function (value) {
        return o.items().some(function (item) { return item.getAttribute('data-value') === value; });
      },
      // show the chosen language on the button (or "More" when one of the 4 buttons is chosen)
      set: function (value) {
        var chosen = null;
        o.items().forEach(function (item) {
          var on = item.getAttribute('data-value') === value;
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) chosen = item;
        });
        if (chosen) {
          button.setAttribute('data-chosen', '');
          if (label) label.textContent = value === 'Other' ? 'Other' : value;
          button.setAttribute('aria-label', 'More languages: ' + chosen.textContent.trim() + ' chosen');
        } else {
          button.removeAttribute('data-chosen');
          if (label) label.textContent = 'More';
          button.setAttribute('aria-label', 'More languages');
        }
      }
    };
  };
})();
